export default __webpack_public_path__ + "static/media/modalImg.25d98a24.png";